import { yupResolver } from "@hookform/resolvers/yup";
import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  FormLabel,
  IconButton,
  MenuItem,
  Select,
} from "@mui/material";
import CloseIcon from "mdi-material-ui/Close";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { axiosInstance } from "src/network/adapter";
import { ApiEndPoints } from "src/network/endpoints";
import * as yup from "yup";
import { toastError, toastSuccess } from "src/utils/utils";

const validationSchema = yup.object().shape({
  status: yup.string().trim().required("Status is required"),
});

const DialogUserStatusUpdate = (props) => {
  const { open, toggle, onSuccess, dataToEdit, endpointType = "CATEGORIES" } = props;
  const [loading, setLoading] = useState(false);

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      status: "",
    },
    resolver: yupResolver(validationSchema),
    mode: "onChange",
  });

  useEffect(() => {
    if (open && dataToEdit) {
      setLoading(false);
      reset({
        status:
          dataToEdit?.is_active !== undefined ? (dataToEdit.is_active ? "0" : "1") : "" || dataToEdit?.status !== undefined ? dataToEdit.status : "",
      });
    }
  }, [dataToEdit, open, reset]);

  const onSubmit = (data) => {
    // Build payload based on endpoint type
    const payload = endpointType === "sub-admin" || endpointType === "USERS"
      ? { status: Number(data.status) }
      : { is_active: data.status === "0" };

    setLoading(true);

    // Dynamic endpoint selection based on endpointType
    const getUpdateStatusEndpoint = (type, id) => {
      switch (type) {
        case "CATEGORIES":
          return ApiEndPoints.CATEGORIES.updateStatus(id);
        case "REGIONS":
          return ApiEndPoints.REGIONS.updateStatus(id);
        case "COURSES":
          return ApiEndPoints.COURSES.updateStatus(id);
        case "MODULES":
          return ApiEndPoints.MODULES.updateStatus(id);
        case "CULTURAL":
          return ApiEndPoints.CULTURAL.updateStatus(id);
        case "USERS":
          return ApiEndPoints.USERS.statusUpdate(id);
        case "sub-admin":
          return ApiEndPoints.SUB_ADMIN.updateStatus(id);
        default:
          return ApiEndPoints.CATEGORIES.updateStatus(id);
      }
    };

    axiosInstance
      .patch(getUpdateStatusEndpoint(endpointType, dataToEdit?.id), payload)
      .then((response) => {
        onSuccess();
        toastSuccess(response.data.message);
        toggle();
      })
      .catch((error) => {
        toastError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  console.log("dataToEdit", dataToEdit)
  return (
    <Dialog open={open} onClose={toggle} fullWidth maxWidth="sm" scroll="paper">
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box>Update Status</Box>
        <IconButton
          aria-label="close"
          onClick={toggle}
          sx={{ color: (theme) => theme.palette.grey[500] }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{ pb: 8, px: { xs: 8, sm: 15 }, pt: { xs: 8, sm: 12.5 } }}
      >
        <form id="coupon-status-form" onSubmit={handleSubmit(onSubmit)}>
          <FormControl fullWidth error={Boolean(errors.status)}>
            <FormLabel htmlFor="status">Status</FormLabel>
            <Controller
              name="status"
              control={control}
              render={({ field: { value, onChange } }) => (
                <Select
                  value={value}
                  onChange={onChange}
                  size="small"
                  fullWidth
                  displayEmpty
                >
                  <MenuItem value="0">Active</MenuItem>
                  <MenuItem value="1">Inactive</MenuItem>
                </Select>
              )}
            />

            {errors.status && (
              <FormHelperText>{errors.status.message}</FormHelperText>
            )}
          </FormControl>
        </form>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          size="large"
          type="submit"
          form="coupon-status-form"
          variant="contained"
          loading={loading}
        >
          Submit
        </LoadingButton>
        <Button
          size="large"
          variant="outlined"
          onClick={toggle}
          sx={{ "&:hover": { backgroundColor: "#fff", color: "#7338AC" } }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogUserStatusUpdate;
